import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { useSelector } from 'react-redux';

const DynastySelector = ({
  onChanged,
  isMulti,
  selectedId,
}) => {
  const { dynastiesList } = useSelector(state => state.dynasties);
  const dynastiesOptions = dynastiesList.map(dynasty => ({
    label: `${dynasty.name} [${dynasty.code}]`,
    value: dynasty.id,
    code: dynasty.code,
  }));
  let selectedItem;
  if (selectedId) {
    if (Array.isArray(selectedId)) {
      selectedItem = dynastiesOptions.filter(x => Array.from(selectedId).includes(x.value));
    } else {
      selectedItem = dynastiesOptions.find(x => x.value === selectedId);
    }
  }
  return (
    <Select
      options={dynastiesOptions}
      isMulti={isMulti}
      value={selectedItem}
      onChange={(value) => {
        if (onChanged) {
          onChanged(value);
        }
      }}
      placeholder="Select Dynasty"
    />
  );
};

DynastySelector.propTypes = {
  onChanged: PropTypes.func,
  isMulti: PropTypes.bool,
  selectedId: PropTypes.number,
};

DynastySelector.defaultProps = {
  onChanged: undefined,
  isMulti: false,
  selectedId: undefined,
};

export default DynastySelector;
